import SkolkovoDesktop from './SkolkovoDesktop.vue';
import useVueCompositionApi from '@/js/common/plugins/use-vue-composition-api';
import { createApp } from '@vue/composition-api';

let isOnPage = document.querySelector('.js-skolkovo');

if(isOnPage) {
    useVueCompositionApi()
    createApp(SkolkovoDesktop).mount('.js-skolkovo')
}